<template>
  <div class="view">
    <div class="content">
      <div class="weui-cell" style="align-items: flex-start">
        <div class="weui-cell__hd pt20" style="width: 800px">
          <el-form ref="form" :model="formdata" label-width="120px">
            <el-form-item label="用户签到">&nbsp;&nbsp;
              <el-radio-group v-model="formdata.is_open" >
                <el-radio :label="1">开启</el-radio>
                <el-radio :label="0">不开启</el-radio>
              </el-radio-group>
              <p class="prompt_infor">&nbsp;&nbsp;&nbsp;开启签到后，用户进入你的小程序个人中心处，头像右侧显示签到功能</p>
            </el-form-item>
            <el-form-item label="签到配置">
              <div class="weui-cell pd0">
                <div class="weui-cell__hd">&nbsp;&nbsp;&nbsp;起止时间：</div>
                <div class="weui-cell__bd">
                  <el-date-picker 
                    v-model="datetime" 
                    type="datetimerange" 
                    range-separator="至" 
                    start-placeholder="开始时间" 
                    end-placeholder="结束时间"
                    format="yyyy/MM/dd HH:mm"
                    :picker-options="pickerOptions"
                    @change="onChangeDate"
                  ></el-date-picker>
                </div>
              </div>
              <p class="mb20 prompt_infor">&nbsp;&nbsp;&nbsp;不设置起止时间就表示，该签到有效期无限制时长</p>
              <div class="weui-cell pd0 mb20">
                <div class="weui-cell__hd"><span class="red">*</span>&nbsp;&nbsp;</div>
                <div class="weui-cell__hd">单次签到积分数量：&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</div>
                <div class="weui-cell__bd">
                  <el-input class="w280" v-model="formdata.single_time">
                    <template slot="append">个</template>
                  </el-input>
                </div>
              </div>
              <div class="weui-cell pd0 mb5">
                <div class="weui-cell__hd">&nbsp;&nbsp;&nbsp;</div>
                <div class="weui-cell__hd">连续签到7天积分数量：</div>
                <div class="weui-cell__bd">
                  <el-input class="w280" v-model="formdata.seven_time">
                    <template slot="append">个</template>
                  </el-input>             
                </div>
              </div>
              <p class="prompt_infor">&nbsp;&nbsp;&nbsp;不设置则表示每周签到获取的积分数量相同</p>
            </el-form-item>  
            <el-form-item>&nbsp;&nbsp;
              <el-button type="primary" @click="formSubmit">保存</el-button>
            </el-form-item>
          </el-form>           
        </div>
        <div class="weui-cell__bd">
          <img src="../../../assets/imgs/signin.png" width="375" />
        </div>
      </div>       
    </div>
  </div>  
</template>

<script>
import api from "@/api.js";
export default {
  name: 'integralSignin',
  data() {
    return {
      formdata: {
        is_open: 0,
        start_time: '',
        end_time: '',
        single_time: 0,
        seven_time: 0
      },
      datetime: [],
      pickerOptions:{
        onPick: (obj) => {
          this.pickerMinDate = new Date(obj.minDate).getTime();
        },
        disabledDate:(time)=> {
          let minTime = Date.now() - 8.64e7
          if (this.pickerMinDate) {
            const day1 =  180 * 24 * 3600 * 1000
            let maxTime = this.pickerMinDate + day1 
            return time.getTime() > maxTime || time.getTime()<minTime 
          }
          else{
            return  time.getTime()<minTime
          }
        }
      },
    }
  },
  mounted() {
    this.axios
        .post(api.points_signInConfig, {})
        .then(response => {
          if (response.data.code == 0) {
            this.formdata = response.data.data;
            if (response.data.data.start_time > 0 && response.data.data.end_time > 0) {
              this.datetime = [parseInt(response.data.data.start_time) * 1000, parseInt(response.data.data.end_time) * 1000];
            }
          } 
        })
        .catch(() => {});
  },
  methods: {
    onChangeDate(value) {
      if (value) {
        this.formdata.start_time = parseInt(value[0] / 1000);
        this.formdata.end_time = parseInt(value[1] / 1000);
      } else {
        this.formdata.start_time = '';
        this.formdata.end_time = '';
      }
    },
    formSubmit() {
      if (this.formdata.is_open == 1 && !this.formdata.single_time) {
        this.$message.error('请填写单次签到积分数量');
        return false
      }
      this.axios
          .post(api.points_setSignInConfig, this.formdata)
          .then(response => {
            if (response.data.code == 0) {
              this.$message.success(response.data.msg);
            } 
          })
          .catch(() => {});      
    }
  }
}
</script>
